import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=1f991a3a&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=1f991a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f991a3a",
  null
  
)

export default component.exports